const tiers = [
  {
    name: "3 Business Days",
    subtitle: "Most Urgent",
    description: "Trip within the next week. Hand-courier delivery with reserved agency slot. Overnight FedEx return.",
    price: "$345",
    cta: "Renew in 3 Days",
    badge: null,
  },
  {
    name: "4 Business Days",
    subtitle: "Most Popular",
    description: "Trip within 1–2 weeks. Priority submission, expedited agency processing.",
    price: "from $295",
    cta: "Renew in 4 Days",
    badge: "Most Popular",
  },
  {
    name: "7 Business Days",
    subtitle: "Reliable",
    description: "Trip within about 2 weeks. Reliable expedited processing.",
    price: "from $245",
    cta: "Renew in 7 Days",
    badge: null,
  },
  {
    name: "9 Business Days",
    subtitle: "Value Speed",
    description: "Trip 2–3 weeks out. Faster than government, lower price point.",
    price: "from $195",
    cta: "Renew in 9 Days",
    badge: null,
  },
  {
    name: "3–5 Weeks",
    subtitle: "Smart Saver",
    description: "Trip more than 3 weeks out. Most affordable option.",
    price: "from $95",
    cta: "Start Renewal",
    badge: null,
  },
];

export default function ProcessingSpeedsSection() {
  return (
    <section className="py-16 md:py-20 bg-[#f7faf9]">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-[#1B4D3E] text-center mb-3">
          Choose Your Renewal Speed
        </h2>
        <p className="text-gray-600 text-center mb-10 max-w-3xl mx-auto">
          Pick the tier that fits your travel date. All tiers include expert document review, courier submission, and overnight FedEx return.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {tiers.map((tier, i) => (
            <div
              key={i}
              className={`relative bg-white rounded-lg border p-6 flex flex-col ${
                tier.badge ? "border-[#C8A951] ring-2 ring-[#C8A951]/30" : "border-gray-200"
              }`}
            >
              {tier.badge && (
                <span className="absolute -top-3 left-6 px-4 py-1 bg-[#C8A951] text-[#1B4D3E] text-xs font-bold rounded-full whitespace-nowrap">
                  {tier.badge}
                </span>
              )}
              <p className="text-xs uppercase tracking-wider text-gray-400 font-semibold mb-2">{tier.subtitle}</p>
              <h3 className="text-xl font-bold text-[#1B4D3E] mb-2">{tier.name}</h3>
              <p className="text-gray-600 text-sm mb-4 flex-1">{tier.description}</p>
              <p className="text-2xl font-bold text-[#1B4D3E] mb-4">{tier.price}</p>
              <a
                href="https://fastpassportcenter.com/checkout/?passport=passport-renewal"
                className="whitespace-nowrap text-center w-full py-3 bg-[#1B4D3E] hover:bg-[#153d2f] text-white font-semibold text-sm rounded-md transition-colors cursor-pointer"
              >
                {tier.cta}
              </a>
            </div>
          ))}
        </div>

        <p className="mt-8 text-sm text-gray-500 text-center max-w-3xl mx-auto">
          Government fees are separate and paid directly to the U.S. Department of State. Fast Passport Center service fees cover document review, courier submission, and overnight return delivery.
        </p>
      </div>
    </section>
  );
}